
$(document).ready(function(){
            var submitIcon = $('.searchbox-icon');
            var inputBox = $('.searchbox-input');
            var searchBox = $('.searchbox');
            var isOpen = false;
            submitIcon.click(function(){
                if(isOpen == false){
                    searchBox.addClass('searchbox-open');
                    inputBox.focus();
                    isOpen = true;
                } else {
                    searchBox.removeClass('searchbox-open');
                    inputBox.focusout();
                    isOpen = false;
                }
            });  
             submitIcon.mouseup(function(){
                    return false;
                });
            searchBox.mouseup(function(){
                    return false;
                });
				
				
            $(document).mouseup(function(){
                    if(isOpen == true){
                        $('.searchbox-icon').css('display','block');
                        submitIcon.click();
                    }
                });
        });
            function buttonUp(){
                var inputVal = $('.searchbox-input').val();
                inputVal = $.trim(inputVal).length;
                if( inputVal !== 0){
                    $('.searchbox-icon').css('display','none');
                } else {
                    $('.searchbox-input').val('');
                    $('.searchbox-icon').css('display','block');
                }
            }
/*search js end*/

/*....................*/



$(document).ready(function() {

	//Default Action
	$(".tab_content").hide(); //Hide all content
	$("ul.tabs01 li:first").addClass("active").show(); //Activate first tab
	$(".tab_content:first").show(); //Show first tab content
	
	//On Click Event
	$("ul.tabs01 li").click(function() {
		$("ul.tabs01 li").removeClass("active"); //Remove any "active" class
		$(this).addClass("active"); //Add "active" class to selected tab
		$(".tab_content").hide(); //Hide all tab content
		var activeTab = $(this).find("a").attr("href"); //Find the rel attribute value to identify the active tab + content
		$(activeTab).fadeIn(); //Fade in the active content
		return false;
	});

});


$(document).ready(function(){
$(".yr_cal").click(function () {
$(".open-main-content01").css("display","block");
$(".open-main-content").css("display","none");
$(".open_month_cal").css("display","none");
});
});

$(document).ready(function(){
$(".mnt_cal").click(function () {
$(".open-main-content01").css("display","none");
$(".open-main-content").css("display","block");
$(".open_month_cal").css("display","none");
});
});

$(document).ready(function(){
$(".month_cal").click(function () {
$(".open_month_cal").css("display","block");
$(".open-main-content").css("display","none");
$(".open-main-content01").css("display","none");
});
});

























//////////////////
// WEBPACK FOOTER
// ./static/material/global/js/custom.js
// module id = 408
// module chunks = 0